export default {
    "en": {
        "passwords": {
            "password": "Passwords must be at least six characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link!",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address."
        },
        "auth": {
            "failed": "These credentials do not match our records.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds.",
            "verified": "Please Check Your Email and Verify Your Email is Valid.",
            "inactive": "Your Account is Inactive.",
            "banned": "This Account is Banned."
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, and dashes.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        }
    },
    "fr": {
        "connection": {
            "connexion_id": "Identifiants de connexion",
            "civility_address": "État civil et adresse",
            "email": "Email",
            "email_confirmation": "Confirmation email",
            "password": "Mot de passe",
            "password_confirmation": "Confirmation mot de passe",
            "forget_password": "Mot de passe oublié ?",
            "buttons": {
                "connection": "Connexion",
                "to_registration": "Création de mon compte",
                "to_connection": "Se connecter",
                "send": "Envoyer",
                "register": "S'inscrire",
                "validate": "Valider"
            },
            "existing_email": "Cette adresse mail existe déjà, pour renouveler votre mot de passe cliquez sur le lien suivant"
        },
        "passwords": {
            "password": "Les mots de passe doivent avoir au moins 6 caractères et la confirmation doit correspondre.",
            "reset": "Votre mot de passe a été modifié !",
            "sent": "Un email contenant un lien de réinitialisation vous a été envoyé !",
            "token": "Ce code de réinitialisation est incorrect.",
            "user": "Aucun utilisateur n'est enregistré avec cette adresse email."
        },
        "auth": {
            "failed": "Ces informations de connexion ne correspondent pas.",
            "general_error": "Vous n'avez pas les droits requis pour effectuer cette action.",
            "throttle": "Vous avez effectué trop de tentatives de connexion. Veuillez ré-essayer dans {seconds} secondes.",
            "unknown": "Une erreur inconnue a eu lieu.",
            "inactive": "Votre compte est inactif. Un administrateur doit activer votre compte",
            "banned": "Ce compte est désactivé.",
            "verified": "Veuillez vérifier vos emails pour valider votre adresse."
        },
        "pagination": {
            "previous": "&laquo; Précédent",
            "next": "Suivant &raquo;"
        },
        "shop": {
            "candidates": {
                "nograde": "n'a pas choisi de classe",
                "campus": "école",
                "applications_list": "Accès aux candidatures",
                "application": "a candidaté en",
                "accepted": "est accepté en",
                "registered": "est admis en",
                "medical": "L'enfant a-t-il besoin d'un suivi de santé ou psychologique particulier ?",
                "diet": "L'enfant a-t-il besoin d'un régime alimentaire particulier ?"
            },
            "offers": {
                "title_loggedin": "Explorez nos offres pédagogiques complémentaires",
                "title_loggedout": "Explorez nos offres pédagogiques",
                "internship": "Explorez nos offres",
                "list": "Liste des offres",
                "description": "Description",
                "advantages": "Les + du stage",
                "conditions": "Conditions",
                "session_choice": "Choisir une session",
                "price": "Valeur",
                "register": "M'inscrire",
                "child_registered": "Inscrits",
                "book": "Réserver",
                "more_internship": "Explorez d'autres offres",
                "schooling_contact": "Je souhaite être contacté par un conseiller"
            },
            "search": {
                "filters": {
                    "destinations": "Destinations",
                    "themes": "Thèmes",
                    "date": "Date de début",
                    "duration": "Durée",
                    "week": "{n} semaine | {n} semaines"
                }
            },
            "cart": {
                "preferences": "Préférences",
                "epreferences": "Ma sélection",
                "price": "Valeurs",
                "checkout": "Paiement",
                "save_item": "Inscrire plus tard",
                "save_schooling": "S'inscrire plus tard",
                "saved_items": "Inscrire plus tard",
                "registrations": "Inscription",
                "schooling": "Formation",
                "sibling_discount": "Réduction famille",
                "discount": "Bénéficiez d'une réduction de {n}% sur le montant de la formation pour un paiement en une fois avant le {d}",
                "internship_discount": "",
                "offers": "Offres complémentaires",
                "nopreference": "Aucune préférence sélectionnée",
                "session_conflict": "plusieurs sessions se chevauchent",
                "register_child": "Enregistrer",
                "no_offer_candidate": "Veuillez vous inscrire pour chaque stage sélectionné",
                "no_offer_cart": "Votre panier est vide"
            },
            "orders": {
                "checkedout": "Paiements en cours de validation",
                "complete": "Paiements confirmés",
                "order_details": "Détails",
                "cancel": "Annuler la commande"
            },
            "dialog": {
                "title": "Boîte de dialogue",
                "cge": "Conditions générales d'inscription"
            },
            "messages": {
                "title": "Boîte de dialogue",
                "message": "Message",
                "documents": {
                    "label": "Vos documents",
                    "cge": "Conditions générales d'inscription",
                    "cgv": "Conditions générales de vente"
                }
            }
        },
        "contact": {
            "jpo": {
                "title": "Inscription aux Journées Portes Ouvertes en présentiel",
                "event_choice": "Choisissez la date de votre choix",
                "jpo_event": "Journée portes ouvertes",
                "meeting_event": "Rencontre à",
                "online_meeting_event": "Rencontre en ligne",
                "training": "Formation envisagée",
                "training_choice": "Sélectionnez une formation",
                "event_select_choice": "Sélectionnez un événement",
                "internship": "Type de scolarité",
                "contact_phone": "Une question ? Contactez le",
                "registered": {
                    "title_jpo": "Vous êtes inscrit(e) à la Journée Portes Ouvertes",
                    "title_encounter": "Vous êtes inscrit(e) à une Rencontre",
                    "title_meeting": "Vous êtes inscrit(e)"
                }
            },
            "atelier": {
                "title": "Inscription à un atelier en présentiel",
                "event_choice": "Choisissez la date de votre choix",
                "atelier_event": "Atelier",
                "training": "Formation envisagée",
                "training_choice": "Sélectionnez une formation",
                "event_select_choice": "Sélectionnez un atelier",
                "internship": "Type de scolarité",
                "contact_phone": "Une question ? Contactez le",
                "registered": {
                    "title_atelier": "Vous êtes inscrit(e) à un atelier"
                }
            },
            "webinar": {
                "title": "Inscription à un Webinaire",
                "event_choice": "Choisissez la date de votre choix",
                "webinar_event": "Webinaire",
                "training": "Formation envisagée",
                "training_choice": "Sélectionnez une formation",
                "event_select_choice": "Sélectionnez un webinaire",
                "internship": "Type de scolarité",
                "contact_phone": "Une question ? Contactez le",
                "registered": {
                    "title_webinar": "Vous êtes inscrit(e) à un Webinaire"
                }
            },
            "jpo_live": {
                "title": "Inscription au Live",
                "send": "Envoyer",
                "event_choice": "Choisissez entre",
                "campus_choice": "ou une visite de votre campus",
                "jpo_event": "Journée portes ouvertes",
                "meeting_event": "Rencontre à",
                "online_meeting_event": "Rencontre en ligne",
                "training": "Formation envisagée",
                "training_choice": "Sélectionnez une formation",
                "event_select_choice": "Sélectionnez un événement",
                "event_select_campus": "Sélectionnez un campus",
                "internship": "Type de scolarité",
                "contact_phone": "Une question ? Contactez le",
                "registered": {
                    "title": "Vous avez reçu un mail !"
                }
            },
            "jpo_doc": {
                "title": "Recevoir de la documentation",
                "send": "Recevoir notre brochure",
                "event_choice": "Campus envisagé",
                "jpo_event": "Journée portes ouvertes",
                "meeting_event": "Rencontre à",
                "online_meeting_event": "Rencontre en ligne",
                "training": "Formation envisagée",
                "training_choice": "Sélectionnez une formation",
                "event_select_choice": "Sélectionnez un campus",
                "internship": "Type de scolarité",
                "contact_phone": "Une question ? Contactez le",
                "registered": {
                    "title": "Vous avez reçu un mail !"
                }
            },
            "form": {
                "title": "Je souhaite être contacté par un conseiller d'éducation",
                "sent": "Demande de contact envoyée",
                "child_last_name": "Nom de votre enfant",
                "child_first_name": "Prénom de votre enfant",
                "child_birthday": "Date de naissance de votre enfant",
                "first_training": "Je suis avant tout intéressé(e) par :",
                "second_training": "Je suis également intéressé(e) par :",
                "success": "Merci de nous avoir contacté !"
            },
            "success": {
                "title": "Merci de nous avoir contacté !",
                "message": "Nous reviendrons vers vous rapidement."
            },
            "registered": {
                "exist": "Cette adresse email est déjà utilisée",
                "connect": "Vous pouvez nous contacter en vous connectant à votre compte",
                "to_login": "Accéder à mon compte"
            }
        },
        "candidate": {
            "general": {
                "admission_process": "Procédure d'admission",
                "application": "Candidature",
                "new_application": "Nouvelle candidature",
                "unknown": "Une erreur s'est produite veuillez réessayer plus tard",
                "levels": {
                    "level": "Niveau",
                    "beginner": "Débutant",
                    "intermediate": "Intermédiaire",
                    "advanced": "Avancé"
                }
            },
            "eschool": {
                "application": "Diplôme",
                "sessions": "Programme à la carte"
            },
            "profile": {
                "edit_profile": "Modifier mon profil",
                "edit_password": "Modifier mon mot de passe",
                "profile_info": "Mon profil",
                "documents": "Vos documents",
                "internship": "Stage",
                "scholar": "Scolarité",
                "order_log": "Historique des paiements",
                "order_canceled": "Commandes annulées"
            },
            "contact": {
                "title": "État civil",
                "image": {
                    "placeholder": "Déposez la photo d'identité <br><hr> <i class=\"is-size-6\">le visage de face, sur fond neutre</i>",
                    "tap": "Appuyez ici pour sélectionner une image <br>depuis votre galerie",
                    "change": "Modifier",
                    "remove": "Supprimer",
                    "select": "Sélectionner une Photo",
                    "selected": "<p>Photo sélectionnée</p>",
                    "edit": "Modifier ma photo",
                    "validation": {
                        "browser": "<p>Votre navigateur ne supporte pas le chargement de fichiers</p>",
                        "size": "Votre photo de profil ne doit pas dépasser 2Mo",
                        "type": "Ce type de fichier n'est pas valide"
                    }
                },
                "gender": {
                    "label": "Civilité",
                    "mister": "M.",
                    "miss": "Mme"
                },
                "sex": {
                    "label": "Sexe",
                    "male": "M",
                    "female": "F"
                },
                "last_name": "Nom",
                "first_name": "Prénom",
                "email": "Email",
                "address": "Adresse",
                "address_complement": "Complément",
                "post_code": "Code postal",
                "city": "Ville",
                "country": "Pays",
                "phone": "Téléphone",
                "birthday": "Date de naissance",
                "birth_place": "Lieu de naissance",
                "nationality": "Nationalité",
                "second_nationality": "Seconde Nationalité",
                "nir_number": "N° de sécurité sociale",
                "passport_number": "Passport N°",
                "passport_validity": "Validité",
                "native_language": "Langue(s) parlée(s) à la maison",
                "siblings": "Nombre de frères et soeurs",
                "retraining": "Etes-vous en reprise d’études / reconversion professionnelle ?",
                "legal_tutor": "Tuteur",
                "tutor_parents": "Parents",
                "tutor_mother": "Mère seulement",
                "tutor_father": "Père seulement",
                "tutor_other": "Autre",
                "garantor": "Choix du contractant",
                "job": "Profession",
                "status": "Statut",
                "tutor": {
                    "label": "Tuteur"
                },
                "father": {
                    "label": "Père / Responsable 1",
                    "status_single": "Célibataire",
                    "status_married": "Marié",
                    "status_widower": "Veuf",
                    "status_divorced": "Divorcé"
                },
                "mother": {
                    "label": "Mère / Responsable 2",
                    "status_single": "Célibataire",
                    "status_married": "Mariée",
                    "status_widower": "Veuve",
                    "status_divorced": "Divorcée"
                },
                "validation": {
                    "email": "Cet email est déjà utilisé par un compte existant.",
                    "tutor": "Veuillez renseigner au moins un tuteur",
                    "empty_field": "Veuillez renseigner les champs requis",
                    "passport": "Date de validité du passport invalide",
                    "birthday": "Date de naissance invalide"
                }
            },
            "choices": {
                "application_step": {
                    "title": "Étape de candidature",
                    "pending": "Candidature en cours de saisie",
                    "sent": "Candidature envoyée",
                    "accepted": "Votre candidature est acceptée.",
                    "registretion_pending": "Veuillez désormais procéder à l'inscription définitive",
                    "registered": "Confirmation de votre inscription",
                    "admission": "Vous êtes {gender}",
                    "m_admission": "inscrit",
                    "f_admission": "inscrite",
                    "current_grade": "Vous êtes en classe de"
                },
                "high_school": {
                    "title": "Formation envisagée",
                    "training_choice": "Choix de la formation",
                    "campus": "Campus"
                },
                "scholar_year": {
                    "label": "Année scolaire",
                    "current": "En cours",
                    "other": "Autre année"
                },
                "year_fees": "Frais de scolarité annuels",
                "debours": "Montant des débours",
                "debours_info": "Provision pour dépenses personnelles de l'élève.",
                "validation": {
                    "training": "Veuillez sélectionner une formation",
                    "section": "Veuillez sélectionner une section",
                    "option": "Veuillez sélectionner une option ou une année",
                    "internship": "Comment souhaitez vous suivre votre scolarité ?"
                },
                "fees_contact": "veuillez appeler le {phone} pour obtenir des informations sur nos tarifs"
            },
            "cursus": {
                "title": "Cursus Académique",
                "grade": {
                    "title": "Classe actuelle",
                    "series": "Choix de la série",
                    "french_system": "Système académique français",
                    "swiss_system": "Système académique suisse",
                    "academic_system": "Système académique :",
                    "other_system": "Autre",
                    "other_country": "Précisez le pays"
                },
                "none": "Aucune",
                "institution": {
                    "title": "Établissement",
                    "name": "Nom",
                    "city": "Ville"
                },
                "languages": {
                    "title": "Langues étudiées",
                    "language": {
                        "label": "Langue",
                        "english": "Anglais",
                        "spanish": "Espagnol",
                        "italian": "Italien",
                        "german": "Allemand",
                        "chinese": "Chinois",
                        "japanese": "Japonais",
                        "russian": "Russe",
                        "portuguese": "Portugais",
                        "arabic": "Arabe classique",
                        "other": "Autre"
                    },
                    "years": "Nombre d'années",
                    "add": "Ajouter une langue"
                }
            },
            "motivations": {
                "school": {
                    "stepA": "Renseignements généraux",
                    "reference": "Pouvez-vous nous indiquer dans quel contexte vous avez été mis en relation avec Diderot Education ? Etes-vous recommandé par une personne en particulier ?",
                    "bac": "A quel examen final donnez-vous aujourd'hui la préférence ?",
                    "french_bac": "Baccalauréat français",
                    "swiss_bac": "Baccalauréat suisse",
                    "international_bac": "Baccalauréat international",
                    "medical": "L'élève a-t-il besoin d'un suivi de santé ou psychologique particulier ?",
                    "diet": "L'élève a-t-il besoin d'un régime alimentaire particulier ?",
                    "stepB": "Faire connaissance",
                    "internship": "L'élève a-t-il déjà séjourné dans un internat ?",
                    "personality": "Comment définiriez-vous en quelques mots la personnalité de l'élève ?",
                    "school_internship": "L'élève a-t-il participé à un stage d'été dans l'un des établissements de Diderot Education ?",
                    "sports": {
                        "title": "Sport(s) pratiqué(s)",
                        "level": "Niveau",
                        "pro": "Pratique en compétition",
                        "years": "Nombre d'années",
                        "add": "Ajouter un sport"
                    },
                    "musics": {
                        "title": "Activité(s) musicale(s)",
                        "level": "Niveau",
                        "years": "Nombre d'années",
                        "add": "Ajouter une activité"
                    },
                    "other_activities": "Autre(s) activité(s)",
                    "yes_response": "Si oui lequel ?",
                    "internship_years": "Si oui, en quelle(s) année(s) ?",
                    "validation": {
                        "text_too_long": "Veuillez raccourcir votre texte"
                    }
                }
            },
            "documents": {
                "title": "Documents",
                "document_drag": "Déposez les documents",
                "interview_report_drag": "Déposez le rapport d'entretien",
                "alternance_contract_drag": "Déposez le contrat d'alternance",
                "id_files": "Pièce d'identité",
                "id_description": "Carte d'identité nationale, passeport et/ou titre de séjour",
                "degree_files": "Diplômes - Notes",
                "degree_description": "Derniers diplomes obtenus et relevés de notes significatifs",
                "documents_complement": "Documents complémentaires",
                "referent_letter": "Lettres de recommandations",
                "sport_licences": "Licences sportives",
                "sport_trophy": "Palmarès sportif",
                "prizes": "Prix d'excellence",
                "video": "Vidéo de présentation",
                "validation": {
                    "no_doc": "Vous n'avez ajouté aucun document",
                    "max_doc": "Nombre maximum de documents atteint",
                    "size_doc": "Document trop lourd"
                }
            },
            "fees": {
                "title": "Frais de dossier",
                "description": "Veuillez régler les frais de dossier par carte bancaire, chèque, virement ou en espèces",
                "bank_cb": {
                    "name": "Carte Bancaire",
                    "selected": "Frais de dossier réglés par carte bancaire",
                    "reference": "Référence de l'opération",
                    "amount": "Montant",
                    "date": "Date",
                    "description": "Vous aller être redirigé vers une interface de paiement",
                    "security": "L’interface de paiement est sécurisée et cryptée par le Crédit Mutuel.",
                    "button": "Je règle par carte bancaire",
                    "error": "Une erreur s'est produite veuillez réessayer plus tard, ou choisir un autre moyen de paiement"
                },
                "bank_check": {
                    "name": "Chèque",
                    "selected": "Vous avez choisi le règlement des frais de dossier par chèque",
                    "1": "Veuillez adresser votre chèque de",
                    "2": "accompagné du",
                    "3": "Bordereau de remise de chèque",
                    "4": "bordereau",
                    "5": "à l'adresse suivante",
                    "button": "Je règle par chèque"
                },
                "bank_transfer": {
                    "name": "Virement",
                    "selected": "Vous avez choisi le règlement des frais de dossier par virement",
                    "1": "Veuillez vous rapprocher de votre banque et effectuer un virement bancaire de",
                    "2": "vers le compte suivant",
                    "button": "Je règle par virement",
                    "instruction": "Merci d'indiquer lors de votre virement la dénomination suivante"
                },
                "bank_note": {
                    "name": "Espèces",
                    "selected": "Vous avez choisi le règlement des frais de dossier en espèces",
                    "1": "Veuillez vous rendre sur le campus de votre choix pour régler les frais de dossier de",
                    "2": "Un reçu vous sera remis et une confirmation de pré-inscription sera envoyée par mail et déposée sur Diderot Max",
                    "button": "Je règle en espèces"
                }
            },
            "registration": {
                "eschool": {
                    "title": "Inscription administrative et paiement",
                    "admission": "Félicitations, vous êtes admissible ! Vous devez maintenant effectuer votre inscription administrative, en suivant ce lien",
                    "shop_link": "Inscrivez-vous et consultez nos parcours à la carte complémentaires"
                }
            },
            "process": {
                "title": "Envoi de la candidature",
                "application_sent": "Votre dossier a été transmis à la direction de l'école. Les informations transmises lui permettront de préparer votre rencontre.",
                "scholar_contract": "Avant de finaliser votre candidature, veuillez lire attentivement le contrat de scolarité",
                "send_candidature": "Envoyer ma candidature pour préparer l'entretien",
                "send_ecandidature": "Envoyer ma candidature",
                "not_complete": "Votre candidature est incomplète"
            },
            "messages": {
                "title": "Boîte de dialogue",
                "message": "Message",
                "documents": {
                    "label": "Vos documents",
                    "accepted": "Confirmation de pré-inscription (admissibilité)",
                    "contract": "Contrat de scolarité",
                    "ofp": "Offre de facilité de paiement",
                    "admission": "Confirmation d'inscription",
                    "certificat": "Certificat de scolarité"
                }
            }
        },
        "menu": {
            "general": {
                "account": "Mon compte",
                "connection": "Se connecter",
                "candidates": "Candidatures",
                "offers": "Offres pédagogiques",
                "sessions": "Sessions de formation",
                "highschool_internship": "Offres complémentaires",
                "internship": "Stages de vacances"
            }
        },
        "payments": {
            "mode": {
                "CB": "carte bancaire",
                "BANK-CHECK": "chèque",
                "BANK-DEBIT": "prélèvement",
                "BANK-TRANSFER": "virement",
                "BANK-NOTE": "espèces"
            }
        },
        "labels": {
            "general": {
                "yes": "Oui",
                "no": "Non",
                "edit": "Modifier",
                "delete": "Supprimer",
                "cancel": "Annuler",
                "save": "Sauvegarder",
                "validate": "Valider",
                "send": "Envoyer",
                "reply": "Répondre",
                "add": "Ajouter"
            }
        },
        "validation": {
            "accepted": "Le champ {attribute} doit être accepté.",
            "active_url": "Le champ {attribute} n'est pas une URL valide.",
            "after": "Le champ {attribute} doit être une date postérieure à {date}.",
            "after_or_equal": "Le champ {attribute} doit être une date postérieure ou égale à {date}.",
            "alpha": "Le champ {attribute} ne peut contenir que des lettres.",
            "alpha_dash": "Le champ {attribute} ne peut contenir que des lettres, des chiffres ou bien des tirets.",
            "alpha_num": "Le champ {attribute} ne peut contenir que des lettres ou des chiffres.",
            "array": "Le champ {attribute} doit être un tableau.",
            "before": "Le champ {attribute} doit être une date antérieure à {date}.",
            "before_or_equal": "Le champ {attribute} doit être une date antérieure ou égale à {date}.",
            "between": {
                "numeric": "La valeur {attribute} doit être comprise entre {min} et {max}.",
                "file": "La taille du fichier {attribute} doit être comprise entre {min} et {max} kilooctets.",
                "string": "La taille de la chaine {attribute} doit être comprise entre {min} et {max} caractères.",
                "array": "Le tableau {attribute} doit contenir entre {min} et {max} éléments."
            },
            "boolean": "Le champ {attribute} doit être vrai ou faux.",
            "confirmed": "La confirmation du champ {attribute} ne correspond pas.",
            "date": "Le champ {attribute} n'est pas une date valide.",
            "date_format": "Le champ {attribute} ne correspond pas au format {format}.",
            "different": "Le champ {attribute} et le champ {other} doivent être différents.",
            "digits": "Le champ {attribute} doit contenir {digits} chiffres.",
            "digits_between": "Le champ {attribute} doit avoir entre {min} et {max} chiffres.",
            "dimensions": "Le champ {attribute} a des dimensions d'image invalides.",
            "distinct": "Le champ {attribute} doit être une valeur unique.",
            "email": "Le champ {attribute} doit être une adresse email valide.",
            "exists": "Le champ {attribute} n'existe pas.",
            "file": "Le champ {attribute} doit être un fichier.",
            "filled": "Le champ {attribute} est obligatoire.",
            "image": "Le champ {attribute} doit être une image.",
            "in": "Le champ {attribute} est invalide.",
            "in_array": "Le champ {attribute} n'existe pas dans {other}.",
            "integer": "Le champ {attribute} doit être un entier.",
            "ip": "Le champ {attribute} doit être une adresse IP valide.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "Le champ {attribute} doit être une chaine JSON valide.",
            "max": {
                "numeric": "Le champ {attribute} doit être inférieur à {max}.",
                "file": "La taille du fichier {attribute} ne peut être supérieure à {max} kilooctets.",
                "string": "Le champ {attribute} doit contenir moins de {max} caractères.",
                "array": "Le tableau {attribute} doit avoir moins de {max} éléments."
            },
            "mimes": "Le fichier {attribute} doit être du type : {values}.",
            "min": {
                "numeric": "Le champ {attribute} doit être supérieur à {min}.",
                "file": "Le taille du fichier {attribute} doit être supérieure à {min} kilooctets.",
                "string": "Le champ {attribute} doit contenir plus de {min} caractères.",
                "array": "Le tableau {attribute} doit avoir plus de {min} éléments."
            },
            "not_in": "Le champ {attribute} est invalide.",
            "numeric": "Le champ {attribute} doit être un nombre.",
            "present": "Le champ {attribute} doit être présent.",
            "regex": "Le format du champ {attribute} est invalide.",
            "required": "Le champ {attribute} est obligatoire.",
            "required_if": "Le champ {attribute} est obligatoire lorsque {other} est {value}.",
            "required_unless": "Le champ {attribute} est obligatoire sauf si {other} est {value}.",
            "required_with": "Le champ {attribute} est obligatoire lorsque {values} a une valeur.",
            "required_with_all": "Le champ {attribute} est obligatoire lorsque {values} existe.",
            "required_without": "Le champ {attribute} est obligatoire lorsque {values} n'a pas de valeur.",
            "required_without_all": "Le champ {attribute} est obligatoire lorsque {values} n'existe pas.",
            "same": "Le champ {attribute} et {other} doivent être identiques.",
            "size": {
                "numeric": "Le champ {attribute} doit avoir une taille de {size}.",
                "file": "La taille du fichier {attribute} doit être de {size} kilooctets.",
                "string": "Le champ {attribute} doit comporter {size} caractères.",
                "array": "Le tableau {attribute} doit contenir {size} éléments."
            },
            "string": "Le champ {attribute} doit être une chaine de caractères.",
            "timezone": "Le champ {attribute} doit être une zone de temps valide.",
            "unique": "Le champ {attribute} existe déjà.",
            "url": "Le format du champ {attribute} est invalide.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": {
                "backend": [],
                "frontend": {
                    "email": "Adresse email",
                    "last_name": "Nom",
                    "first_name": "Prénom",
                    "name": "Nom",
                    "address": "Adresse",
                    "postcode": "Code postal",
                    "city": "Ville",
                    "password": "Mot de passe",
                    "password_confirmation": "Confirmation",
                    "phone": "Téléphone",
                    "message": "Message",
                    "old_password": "Ancien mot de passe",
                    "new_password": "Nouveau mot de passe",
                    "new_password_confirmation": "Confirmation du nouveau mot de passe"
                }
            }
        },
        "offers": {
            "candidates": {
                "nograde": "n'a pas choisi de classe",
                "campus": "école",
                "applications_list": "Accès aux candidatures",
                "application": "a candidaté en",
                "accepted": "est accepté en",
                "registered": "est admis en",
                "medical": "L'enfant a-t-il besoin d'un suivi de santé ou psychologique particulier ?",
                "diet": "L'enfant a-t-il besoin d'un régime alimentaire particulier ?"
            },
            "offers": {
                "title_loggedin": "Explorez nos offres pédagogiques complémentaires",
                "title_loggedout": "Explorez nos offres pédagogiques",
                "internship": "Explorez nos offres de stages",
                "additional": "Offres complémentaires",
                "training": "Offres de formations",
                "list": "Liste des offres",
                "description": "Description",
                "advantages": "Les + du stage",
                "conditions": "Conditions",
                "session_choice": "Choisir une session",
                "free_session_choice": "Date de transfert envisagée",
                "free_session_validation": "Valider",
                "price": "Valeur",
                "register": "Inscrire",
                "child_registered": "Inscrits",
                "book": "Réserver",
                "more_internship": "Explorez d'autres stages",
                "doc_request": "Recevoir une documentation",
                "doc_request_sent": "Demande de documentation envoyée"
            },
            "search": {
                "filters": {
                    "destinations": "Destinations",
                    "themes": "Thèmes",
                    "date": "Date de départ",
                    "duration": "Durée",
                    "week": "{n} semaine | {n} semaines"
                }
            },
            "cart": {
                "preferences": "Préférences éducatives",
                "epreferences": "Ma sélection",
                "price": "Valeurs",
                "checkout": "Paiement",
                "save_item": "Inscrire plus tard",
                "save_schooling": "S'inscrire plus tard",
                "saved_items": "Inscrire plus tard",
                "registrations": "Inscription de",
                "schooling": "Scolarité",
                "sibling_discount": "Réduction famille",
                "discount": "Bénéficiez d'une réduction de {n}% sur le montant de la scolarité pour un paiement en une fois avant le {d}",
                "internship_discount": "",
                "offers": "Offres complémentaires",
                "nopreference": "Aucune préférence sélectionnée",
                "session_conflict": "plusieurs sessions se chevauchent",
                "childs": "Vos enfants",
                "save_child": "Enregistrer un enfant",
                "add_child": "Ajouter un enfant",
                "register_child": "Enregistrer",
                "no_offer_candidate": "Veuillez inscrire un enfant pour chaque stage sélectionné",
                "credit": "Vous disposez d'un avoir de",
                "credit_field": "Indiquez le montant que vous souhaitez utiliser"
            },
            "orders": {
                "checkedout": "Paiements en cours de validation",
                "complete": "Paiements confirmés",
                "order_details": "Détails",
                "cancel": "Annuler la commande"
            },
            "dialog": {
                "title": "Boîte de dialogue",
                "cge": "Conditions générales d'inscription"
            },
            "messages": {
                "title": "Boîte de dialogue",
                "message": "Message",
                "documents": {
                    "label": "Vos documents",
                    "cge": "Conditions générales d'inscription"
                }
            },
            "0": ""
        }
    }
}
